export default function getResponsiveSpacing({
  maxScreen,
  minScreen,
  maxSpacing,
  minSpacing,
  stepPx,
  stepDrop
}: {
  maxScreen: number;
  minScreen: number;
  maxSpacing: number;
  minSpacing: number;
  stepPx: number;
  stepDrop: number;
}) {
  if (typeof window === "undefined") return maxSpacing;
  const width = window.innerWidth;
  if (width >= maxScreen) return maxSpacing;
  if (width <= minScreen) return minSpacing;

  const steps = Math.floor((maxScreen - width) / stepPx);
  const spacing = maxSpacing - steps * stepDrop;
  return Math.max(spacing, minSpacing);
}